// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1AoXy","tab":"Tabs_tab__37asj","tabActive":"Tabs_tabActive__1E8Yg"};